/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, TextField, CircularProgress, Tooltip } from '@material-ui/core'
import { Autocomplete, ToggleButtonGroup, ToggleButton } from '@material-ui/lab'

import { List, Search } from '@material-ui/icons' 

import Actions from '../../../../fluid/Actions/ActionFactory'

import FieldTable from '../components/Fields/FieldTable';
import FieldDetail from '../components/Fields/FieldDetail';

import Field from '../components/Fields/Field';

const blue_theme = createTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    badge: {
        padding: `0 ${theme.spacing.unit * 0}px`,
    }
})
class SingletonSpace extends Component {
    state = {
        loading_singletons : false,
        loading_singletons_error : false,
        singletons : null,
        search_results : null,
        singleton_filter : {
            direction : null,
            count : null,
            range : {
                lower : null,
                upper : null
            }
        },
        focussed_singleton : null,
        options : [],
        open : false,
        loading : false,
        loadingText : "Enter at least 3 characters to filter.",
        search_term : "",
        noOptionsText : "Enter at least 3 characters to filter.",
        showing : "all_results"
    }

    componentDidMount () {
        // let singleton_filter = {
        //     direction : null,
        //     count : null,
        //     range : {
        //         lower : null,
        //         upper : null
        //     }
        // }
        // if (this.props.report_info.num_singleton_columns < 25) {
        //     singleton_filter.direction = "All"
        // } else {
        //     singleton_filter.direction = "Top"
        //     singleton_filter.count = 25
        // }

        // this.setState({...this.state, singleton_filter : singleton_filter}, () => {
        //     this.getSingletons()
        // })
        this.getSingletons()
    }

    componentDidUpdate (prevProps) {
        var equal = require('fast-deep-equal');
        // if (!equal(prevProps.group_in_focus, this.props.group_in_focus)) {
        //     this.getSingletons()
        // }

        if (!equal(prevProps.report_info, this.props.report_info)) {
            this.getSingletons()
        }

        if (!equal(prevProps.global_fields, this.props.global_fields)) {
            this.getSingletons(() => {
                if (this.state.focussed_singleton !== null) {
                    let focussed_singleton = this.state.singletons.find(singleton => singleton.field === this.state.focussed_singleton.field)
                    this.setState({...this.state, focussed_singleton : focussed_singleton})
                }
            })
        }

        if (prevProps.syncing_field !== null && this.props.syncing_field === null) {
            console.log("IFC :: Syncing Field Complete: ", prevProps.syncing_field)
            if (this.state.showing === 'search_results') {
                let syncing_field_index = this.state.options.findIndex(field => field.field === prevProps.syncing_field)
                console.log("IFC :: Syncing Field Index: ", syncing_field_index)
                if (syncing_field_index !== -1) {
                    this.search()
                }
            }
        }

        if (prevProps.unsynced_fields.length !== 0 && this.props.unsynced_fields.length === 0) {
            if (this.state.showing === 'search_results') {
                this.search()
            }
        }
    }

    // getRange = () => {
    //     let lower_index
    //     let upper_index

    //     if (this.state.singleton_filter.direction === "All") {
    //         lower_index = 0
    //         upper_index = this.props.report_info.report_summary.num_singleton_fields.value
    //     }

    //     if (this.state.singleton_filter.direction === "Top") {
    //         lower_index = 0
    //         upper_index = this.state.singleton_filter.count
    //     }

    //     if (this.state.singleton_filter.direction === "Bottom") {
    //         lower_index = this.props.report_info.report_summary.num_singleton_fields.value - this.state.singleton_filter.count
    //         upper_index = this.props.report_info.report_summary.num_singleton_fields.value
    //     }

    //     if (this.state.singleton_filter.direction === "Range") {
    //         lower_index = this.state.singleton_filter.range.lower
    //         upper_index = this.state.singleton_filter.range.upper
    //     }

    //     let range = [lower_index, upper_index]
    //     return range
    // }

    getSingletons = (chained_func) => {
        this.setState({...this.state, loading_singletons_error : false}, () => {
            // console.log("IFC :: Singleton Range: ", this.getRange())
            // let lower_index = this.getRange()[0]
            // let upper_index = this.getRange()[1]
            Actions('http_request', {
                url : "/sainapse/ifc/singletons",
                method : "post",
                data : {
                    ic_name : this.props.ic_name,
                    version : this.props.version,
                    lower_idx : 0,
                    upper_idx : this.props.report_info.report_summary.num_singleton_fields.value
                }
            }).then(res => {
                console.log("IFC :: Singleton API Response :", res)
                this.setState({...this.state, loading_singletons_error : false, singletons: res.data.result.Result.map(singleton => {
                    return {
                        field : singleton.field_name,
                        group_id : 'singletons',
                        score : null,
                        global_mapped_field : singleton.global_mapped_field
                    }
                })}, () => {
                    console.log("IFC :: Singleton State : ", this.state)
                    if (chained_func) {
                        chained_func()
                    }
                })
            }).catch(err => {
                this.setState({...this.state, loading_singletons_error : true, singletons: null})
            })
        })
    }

    renderLevel1 = () => {
        return (
            <Paper
                style = {{
                    width : '100%',
                    height  : '50px',
                    display : 'flex',
                    flexDirection : 'row',
                    alignItems : 'center',
                    paddingLeft : '15px'
                }}
                square 
                variant = 'outlined' 
            >
                <Typography style = {{margin : 0, padding : 0}} variant = 'subtitle2' color = 'textPrimary'>{"Singletons (" + this.props.report_info.report_summary.num_singleton_fields.value + ")"}</Typography>
            </Paper>
        )
    }

    focusSingleton = (field_object, field_type) => {
        console.log("IFC :: Focussing Singleton : ", field_object )
        this.props.close_field_similarity()
        this.setState({...this.state, focussed_singleton : field_object}, () => {
            if (field_object === null) {
                this.props.update_state({
                    singleton_in_focus : null
                },() => this.props.update_space_state(3, null))
            } else {
                this.props.update_state({
                    singleton_in_focus : field_object
                },() => this.props.update_space_state(3, 'field_detail'))
            }
        })
    }

    onChangeHandle = (value) => {
        this.setState({...this.state, search_term : value}, () => {
            if (this.state.search_term.length > 2) {
                this.setState({...this.state, loading : true, loadingText: "Loading..."}, () => this.search())
            } else {
                this.setState({
                    ...this.state, 
                    loading : false, 
                    options : [], 
                    loadingText: "Enter at least 3 characters to filter.", 
                    noOptionsText : "Enter at least 3 characters to filter.",
                    showing : "all_results"
                })
            }
        })
    }

    search = () => {
        Actions('http_request', {
            url : "/sainapse/ifc/search",
            method : "post",
            data : {
                ic_name : this.props.ic_name,
                version : this.props.version,
                key : this.state.search_term
            }
        }).then(res => {
            let options = res.data.result.Result.singletons
            this.setState({
                ...this.state, 
                loading : false, 
                loadingText : "Results loaded...", 
                options : options, 
                noOptionsText : options.length === 0 ? "No Results..." : "Enter at least 3 characters to filter.",
                showing : "search_results"
            })
        })
    }

    renderTable = () => {
        if (this.state.singletons !== null) {
            let columns = ["$icon", "Name", "$options"]
            return (
                <div style = {{width : '100%', height : this.props.space_height + "px", overflow : 'hidden'}}>
                    {/* <div style = {{padding : '5px'}}>
                        <Filter 
                            key = {'singleton_filter'} 
                            report_info = {this.props.report_info} 
                            count_field = {"num_singleton_fields"}
                            group_filter = {this.state.singleton_filter}
                            update_filter = {(filter) => this.setState({...this.state, singleton_filter : filter}, () => this.getSingletons())}
                        />
                    </div> */}
                    {/* <Autocomplete
                        onOpen={() => {
                            this.setState({...this.state, open : true});
                        }}
                        onClose={() => {
                            this.setState({...this.state, open : false, loading : false, noOptionsText : "Enter at least 3 characters to filter.", options: []});
                        }}
                        open = {this.state.open}
                        loading = {this.state.loading}
                        options = {this.state.options}
                        openOnFocus = {true}
                        getOptionLabel = {(option) => option.field}
                        noOptionsText = {this.state.noOptionsText}
                        renderInput={(params) => <TextField 
                            {...params}
                            style = {{margin : '5px', width : '23vw'}} 
                            label={this.props.search_label} 
                            variant="outlined" 
                            size = 'small'
                            onChange={ev => this.onChangeHandle(ev.target.value)}
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <React.Fragment>
                                    {this.state.loading ? (
                                      <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                  </React.Fragment>
                                )
                              }}
                        />}
                        renderOption = {(field) => {
                            return (
                                <Field
                                    key = {field.field}
                                    field_data = {field}
                                    group_display_name = {this.props.group_display_name}
                                    field_display_name = {this.props.field_display_name}
                                    location = {this.props.location}
                                    field_in_focus = {null}
                                    focus_field = {(field_object, field_type, event) => {
                                        event.stopPropagation();
                                        event.nativeEvent.stopImmediatePropagation();
                                        let singleton = this.state.singletons.find(singleton => singleton.field === field_object.field)
                                        this.focusSingleton(singleton, field_type)
                                    }}
                                    field_type = {'singleton'}
                                    handleDropped = {(field_data, field_type, drop_result) => {
                                        if (drop_result) {
                                            this.props.move_field(field_data, field_type, drop_result)
                                        }
                                    }}
                                    columns = {["$icon", "Name"]}
                                    syncing_field = {this.props.syncing_field}
                                    unfocus_field = {() => this.focusSingleton(null, 'singleton')}
                                    unsynced_fields = {this.props.unsynced_fields}
                                    remove_field = {(field) => this.props.remove_field(field)}
                                    create_new_group_from_field = {(field_data) => {
                                        let singleton = this.state.singletons.find(singleton => singleton.field === field_data.field)
                                        this.props.create_new_group_from_field(singleton)
                                    }}
                                    make_singleton = {(field_data) => this.props.make_singleton(field_data)}
                                    show_group_name = {this.props.show_group_name}
                                    highlight_name = {this.props.highlight_name}
                                />
                            )
                        }}
                    /> */}
                    <div style = {{padding : '10px'}}>
                        <TextField 
                            style = {{ width : '100%'}} 
                            label={this.props.search_label} 
                            variant="outlined" 
                            size = 'small'
                            value = {this.state.search_term}
                            helperText = {this.state.loadingText}
                            onChange={ev => this.onChangeHandle(ev.target.value)}
                            InputProps={{
                                endAdornment: (
                                    <React.Fragment>
                                    {this.state.loading ? (
                                        <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    </React.Fragment>
                                )
                                }}
                        />
                    </div>
                    <div style = {{paddingLeft : '10px', paddingRight : '10px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                        <div style = {{flexGrow : 1, display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                            <Typography variant = 'body2' color = 'primary'>{"Showing "}</Typography>
                            <Typography style = {{marginLeft : '5px'}} variant = 'body2' color = 'primary'>{this.state.showing === "search_results" ? " search results." : " all singletons."}</Typography>
                        </div>
                        <ToggleButtonGroup size = 'small' value = {this.state.showing} exclusive onChange={(event, newValue) => this.setState({...this.state, showing : newValue})}>
                            <ToggleButton value = "all_results">
                                <List/>
                            </ToggleButton>
                            <ToggleButton value = "search_results" disabled = {this.state.options.length === 0}>
                                <Search/>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </div>
                    <FieldTable 
                        body_height = {this.props.space_height - 130}
                        top_margin = "0px"
                        fields = {this.state.showing === "search_results" ? this.state.options : this.state.singletons}
                        field_in_focus = {null}
                        location = {"Singletons"}
                        field_type = {'singleton'}
                        focus_field = {(field_object, field_type) => this.focusSingleton(field_object, field_type)}
                        accept_field_drops = {false}
                        columns = {columns}
                        move_field = {(field_data, field_type, drop_result) => this.props.move_field(field_data, field_type, drop_result)}
                        syncing_field = {this.props.syncing_field}
                        unsynced_fields = {this.props.unsynced_fields}
                        create_new_group_from_field = {(field_data) => this.props.create_new_group_from_field (field_data)}
                        pagination = {true}
                        group_filter = {this.props.singleton_filter}
                        update_filter = {(singleton_filter) => this.props.update_filter(singleton_filter)}
                        allow_mapping_global_field = {true}
                    />
                </div>
            )
        }
    }

    renderFieldDetail = () => {
        return (
            <div style = {{width : '100%', height : this.props.space_height + "px", overflow : 'hidden'}}>
                <FieldDetail
                    global_field_display_name = {this.props.global_field_display_name}
                    key = {'singletons-field-detail'}
                    body_height = {this.props.space_height - 50}
                    ic_name = {this.props.ic_name} 
                    version = {this.props.version} 
                    report_info = {this.props.report_info}
                    global_fields = {this.props.global_fields}
                    global_fields_error = {this.props.global_fields_error}
                    mapping_global_field = {this.props.mapping_global_field}
                    map_global_field = {(entity_id, global_field) => {
                        this.mapGlobalField(entity_id, global_field)
                    }}
                    create_global_field = {(entity_id, new_field_name) => this.props.create_global_field(entity_id, new_field_name)}
                    field_in_focus = {this.state.focussed_singleton}
                    field_type = {'singleton'}
                    from = {'Singletons'}
                    unfocus_field = {(field_object) => this.focusSingleton(null, null)}
                    column_index = {this.props.column_index}
                    checking_field_similarity = {this.props.checking_field_similarity}
                    field_similarity_col_indices = {this.props.field_similarity_col_indices}
                    allow_mapping_global_field = {true}
                    close_field_similarity = {() => this.props.close_field_similarity()}
                />
            </div>
        )
    }

    mapGlobalField = (entity_id, global_field) => {
        this.props.backdrop_enabler({backdrop_enable : true})
        Actions('http_request', {
            url : "/sainapse/ifc/change_mapping",
            method : "post",
            data : {
                entity : entity_id,
                global_field : global_field !== null ? global_field.global_field : null,
                ic_name : this.props.ic_name,
                version : this.props.version
            }
        }).then(res => {
            this.getSingletons(() => {
                let refreshed_focussed_field = this.state.focussed_singleton ? this.state.singletons.find(singleton => singleton.field === this.state.focussed_singleton.field) : null
                this.setState({...this.state, focussed_singleton : refreshed_focussed_field}, () => this.props.refresh_data())
            })
        })
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <div style = {{width : '100%', height : '100%', overflow : 'hidden'}}>
                    {this.renderLevel1()}
                    {this.state.focussed_singleton && this.renderFieldDetail()}
                    {/* {this.state.focussed_singleton === null && this.renderTable()} */}
                    {this.renderTable()}
                </div>
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(SingletonSpace);